import SC from "./style";
import { Button } from "@InnoUI/";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { showAlert } from "utils/helper";
import theme from "@theme/";
import { addCart } from "@store/cart/actions";
import { Pagination } from "antd";

import DocumentCard from "../../DocumentCard";
import { useSelector } from "react-redux";

const FileTable = (props) => {
  const {
    record,
    pageSize,
    currentPage,
    documentData = [],
    searchKey = "",
    setPageSize = () => {},
    setCurrentPage = () => {},
    chatUI = false,
  } = props;
  const [selectedItems, setSelectedItems] = useState([]);
  const dispatch = useDispatch();

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || [],
  );

  const handlePagination = (page, pageSize) => {
    setPageSize(pageSize);
    setCurrentPage(page);
  };

  const handleAddToCart = async () => {
    if (selectedItems.length === 0) {
      showAlert({
        title: "Warning",
        text: "Please select a file.",
        icon: "warning",
      });
      return;
    }
    const data = {
      id: currentProject.id,
      files: selectedItems,
    };
    dispatch(addCart(data));
    setSelectedItems([]);
  };

  console.log(documentData[0]?.files?.length, documentData, record, "klklklk");

  return (
    <SC.CardContainer>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <p style={{ fontWeight: 500 }}>
          Total Record: {record || documentData[0]?.files?.length || 0}
        </p>
        {(record || documentData[0]?.files?.length) > 0 && (
          <Pagination
            total={record || documentData[0]?.files?.length || 0}
            current={currentPage}
            pageSize={pageSize}
            showSizeChanger
            pageSizeOptions={["10", "20", "50", "100"]}
            showTotal={(total, range) =>
              `${range[0]}-${range[1]} of ${total} items`
            }
            onChange={(page, size) => handlePagination(page, size)}
            style={{
              padding: "20px",
              textAlign: "right",
              justifyContent: "end",
            }}
          />
        )}
      </div>

      <SC.TopRow>
        <SC.RowWrapper style={{ width: "100%" }}>
          <SC.ColumnMore></SC.ColumnMore>

          <SC.ColumnDescription>
            Description
            {documentData[0]?.files?.length > 0 && selectedItems.length > 0 && (
              <Button
                caption={"Add to cart"}
                color={theme.colors.themeColor}
                fontSize="12px"
                style={{
                  minWidth: "100px",
                  height: "32px",
                  borderRadius: "6px",
                  border: `1px solid ${theme.colors.themeColor}`,
                  backgroundColor: "#fff",
                  color: theme.colors.themeColor,
                  marginLeft: "20px",
                }}
                onClick={handleAddToCart}
              />
            )}
          </SC.ColumnDescription>

          <SC.MetaBlock>
            <SC.ColumnSize>Size</SC.ColumnSize>
            <SC.ColumCreatedBy>Created By</SC.ColumCreatedBy>
            <SC.ColumRivision>Revision</SC.ColumRivision>
            <SC.ColumnDate>Date</SC.ColumnDate>
            <SC.ColumnCart>Cart</SC.ColumnCart>
          </SC.MetaBlock>
        </SC.RowWrapper>
      </SC.TopRow>

      {documentData[0]?.files?.length > 0 ? (
        documentData.map((item) => (
          <React.Fragment key={item?.property}>
            <SC.Header>{item?.property}</SC.Header>
            {item?.files?.map((file) => (
              <DocumentCard
                key={file.id}
                file={file}
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
                searchKey={searchKey}
                partialSearch={true}
                chatUI={chatUI}
              />
            ))}
          </React.Fragment>
        ))
      ) : (
        <SC.NoDataMessage>Nothing found for {searchKey}</SC.NoDataMessage>
      )}

      {(record || documentData[0]?.files?.length) > 0 && (
        <Pagination
          total={record || documentData[0]?.files?.length || 0}
          current={currentPage}
          pageSize={pageSize}
          showSizeChanger
          pageSizeOptions={["10", "20", "50", "100"]}
          showTotal={(total, range) =>
            `${range[0]}-${range[1]} of ${total} items`
          }
          onChange={(page, size) => handlePagination(page, size)}
          style={{
            padding: "20px",
            textAlign: "right",
            justifyContent: "end",
          }}
        />
      )}
    </SC.CardContainer>
  );
};

export default FileTable;
